<template>
    <div class="businessTemplateManage">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>商业专题</el-breadcrumb-item>
            <el-breadcrumb-item>组件管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button-group class="add-template-btn">
            <el-button class="add-template" type="primary" size="small" @click="addTemplate">+添加组件</el-button>
        </el-button-group>
        <el-table class="business-template-list-table" :data="templateList" stripe border>
            <el-table-column label="组件ID" align='center'>
                <template scope="scope">
                    <span>{{scope.row.newsTypeId}}</span>
                </template>
            </el-table-column>
            <el-table-column label="组件名称" align='center'>
                <template scope="scope">
                    <span>{{scope.row.newsTypeName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align='center'>
                <template scope="scope">
                    <el-button size="small" type="info" @click="">编辑</el-button>
                    <el-button size="small" type="danger" @click="deleteTemplate(scope.row.newsTypeId)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="添加组件" v-model="config.addTemlateDialog.visible"  @close="closeAddTemplateDialog">
            <el-form :model="addTemplateForm" :rules="validateRules" ref="addTemplateForm">
                <el-form-item label="名称" prop="newsTypeName">
                    <el-input v-model="addTemplateForm.newsTypeName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="newsTypeContent">
                    <el-input type="textarea" v-model="addTemplateForm.newsTypeContent" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="config.addTemlateDialog.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitTemplate('addTemplateForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: "businessTemplateManage",
    data() {
        return {
            templateList: null,
            addTemplateForm: {
                newsTypeName: null,
                newsTypeContent: null
            },
            config: {
                addTemlateDialog: {
                    visible: false
                }
            },
            validateRules:{
                newsTypeName: [
                    { required: true, message: '请填写组件名称', trigger: 'blur' }
                ],
                newsTypeContent: [
                    { required: true, message: '请填写组件描述', trigger: 'blur' }
                ]
            }
        };
    },
    mounted(){
        this._init();
    },
    computed: {
        ...mapGetters({
            userInfo: 'getUserInfo'
        })
    },
    methods: {
        _getTemplate(){
            this.$http.get(CONFIG.HOST + '/template/list' + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.templateList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);          
        },
        deleteTemplate(newsTypeId) {
            this._confirmMessage('是否确定删除newsTypeId=' + newsTypeId + '的商业专题组件？', ()=>{
                if (newsTypeId < 0) {
                    this.$notify.error({
                        message: '【营销平台】newsTypeId=' + newsTypeId + '的组件不存在'
                    });
                    return;
                }
                this.$http.delete(CONFIG.HOST + '/template/deleteTpl/' + newsTypeId).then((response)=>{
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: '【营销平台】成功删除newsTypeId=' + newsTypeId + '的商业专题组件'
                        });
                        this._getTemplate();
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                },(response)=>{
                    console.log(response);
                });
            });
        },
        addTemplate(){
            this.config.addTemlateDialog.visible = true;
        },
        submitTemplate(formName){
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            this.$http.post(CONFIG.HOST + '/template/add', this.addTemplateForm).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】商业专题组件创建成功'
                    });
                    this.closeAddTemplateDialog();
                    this._getTemplate();
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _clearFormData(){
            for(let key in this.addTemplateForm){
                this.addTemplateForm[key] = null;
            }
        },
        closeAddTemplateDialog(){
            this.config.addTemlateDialog.visible = false;
            this._clearFormData();
        },
        _init() {
            this._getTemplate();
        }
    }
};
</script>
<style lang="less">
    .businessTemplateManage{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .business-template-list-table{
            min-width: 980px;
        }
        .add-template-btn{
            margin-bottom: 10px;
            width: 100%;
            .add-template{
                margin-right: 0;
                float: right;
            }
        }
        .page-control{
            margin: 20px auto 0 auto;
        }
    }  
</style>


// WEBPACK FOOTER //
// Template.vue?3f8a9098